(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_fo-quality-rotator"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeQualityBlocks = (scope = document) => {
      scope.querySelectorAll('[data-fo-quality-rotator]').forEach((root) => {
        if (root.dataset.foQualityInitialized === 'true') return;

        const tabs = Array.from(root.querySelectorAll('[data-fo-quality-tab]'));
        const panels = Array.from(root.querySelectorAll('[data-fo-quality-panel]'));
        let activeIndex = 0;

        const selectPanel = (index, moveFocus = false) => {
          activeIndex = (index + tabs.length) % tabs.length;
          tabs.forEach((tab, tabIndex) => {
            const isActive = tabIndex === activeIndex;
            tab.setAttribute('aria-selected', String(isActive));
            tab.tabIndex = isActive ? 0 : -1;
            panels[tabIndex].hidden = !isActive;
          });
          if (moveFocus) tabs[activeIndex].focus();
        };

        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => selectPanel(index));
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            let nextIndex = activeIndex;
            if (event.key === 'ArrowLeft') nextIndex -= 1;
            if (event.key === 'ArrowRight') nextIndex += 1;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            selectPanel(nextIndex, true);
          });
        });

        root.dataset.foQualityInitialized = 'true';
        selectPanel(0);
      });
    };

    initializeQualityBlocks();
    document.addEventListener('shopify:section:load', (event) => initializeQualityBlocks(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_fo-tutorial-video"] && !Shopify.designMode) return;
  try {
    if (!window.foTutorialVideoLiteReady) {
    window.foTutorialVideoLiteReady = true;

    document.addEventListener('click', (event) => {
      const button = event.target.closest('.fo-tutorial-video__play');
      if (!button) return;

      const container = button.closest('.fo-tutorial-video__media--lite');
      const videoId = container?.dataset.foVideoId;
      if (!container || !videoId) return;

      const iframe = document.createElement('iframe');
      iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
      iframe.title = container.dataset.foVideoTitle || '';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      container.replaceChildren(iframe);
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.contact-form__form').forEach(formElement => {
    if (formElement.dataset.honeypotReady === 'true') return;
    formElement.dataset.honeypotReady = 'true';
    formElement.addEventListener('submit', event => {
      const honeypot = formElement.querySelector('[data-contact-honeypot]');
      if (honeypot?.value.trim()) event.preventDefault();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
